import { Box, Divider, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import { getChallanById, createChallanFromPOJOId, saveChallan, updateAvailableQty } from '../order.services';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { formatTo0Decimal, isEmpty, isNotEmpty, isNotNull } from '../../common/util.services';
import IGridComponent from '../../../components/grid/i-grid.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import { Visibility } from '@mui/icons-material';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { GET_ALL_TRANSPORTER_URL, LFH_HOME } from '../../common/constants';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PrintChallanForm from './print-challan-form.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import { MATERIAL_SPECS_MAP, SpecListItem } from '../../master-data/specs/specs.mapping';

const ChallanForm = (props: any) => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rows: GridRowsProp = [];
  const [challanDetail, setChallanDetail] = useState(rows);
  const [challanData, setChallanData] = useState<any>({});
  const challanId = params.challanId;
  const [prdType, setPrdType] = useState('Made-up');
  const [source, setSource] = useState('');
  const [destination, setDestination] = useState('');
  const [loader, setLoader] = useState(true);
  const {state} = useLocation();
  const [type, setType] = useState('');
  const [pojoType, setPOJOType] = useState('');
  const [materialCost, setMaterialCost] = useState(0);
  const [processingCost, setProcessingCost] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [plannedOutput, setPlannedOutput] = useState(0);
  const [rowValue, setRowValue] = useState([]);
  const [openInput, setOpenInput] = useState(false);
  const [inputLabel, setInputLabel] = useState('');
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openEditPrint, setOpenEditPrint] = useState(false);
  const [challanDetailId, setChallanDetailId] = useState(null);
  const {pojoData, stockModel} = state;
  const [matChallanType, setMatChallanType] = useState(['Goods Receipt', 'PO Return']);
  const [nonMatChallanType, setNonMatChallanType] = useState(['Material Issue', 'Material Receipt', 'JO Return']);
  const [showDetails, setShowDetails] = useState(true);
  const columns: GridColDef[] = [
    { 
      field: 'inputCode', headerName: 'Input Code', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params) => { return <div className={'NA' === params.row.inputCode ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>{params.row.inputCode}</div>}
    },
    { 
      field: 'inputDesc', headerName: 'Input Description', filterable: false, sortable: false, editable: false, width: 320,
    },
    { 
      field: 'inputQuantity', headerName: 'Required Input', filterable: false, sortable: false, editable: false, width: 220,
      renderCell: (params: any) => 'NA' === params.row.inputCode ? 'NA' : 
                                   formatTo0Decimal(params.row.inputQuantity) + ' ' + params.row.inputUom
    },
    { 
      field: 'availableInput', headerName: 'Available Input', filterable: false, sortable: false, editable: false, width: 220,
      renderCell: (params: any) => 'NA' === params.row.inputCode ? 'NA' : 
                                   formatTo0Decimal(params.row.availableInput) + ' ' + params.row.inputUom
    },
    { 
      field: 'plannedInput', headerName: 'Planned Input', filterable: false, sortable: false, editable: false, width: 220,
      renderCell: (params: any) => isEmpty(params.row.plannedInput) ? '0 ' + params.row.inputUom : 
                                   formatTo0Decimal(params.row.plannedInput) + ' ' + params.row.inputUom
    },
    { 
      field: 'materialCost', headerName: 'Material Cost', filterable: false, sortable: false, editable: false, width: 220,
      valueFormatter: (materialCost: any) => isEmpty(materialCost) ? '' : '₹ ' + formatTo0Decimal(materialCost)
    },
    { 
      field: 'print', headerName: 'Print', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params) => (<EditNoteOutlinedIcon fontSize='medium' color="secondary"/>)
    }
  ];
  
  useEffect(() => {
    if(isNotNull(challanId)) {
      getChallanById(challanId, appContext,
      (response: any) => {
        setMatChallanType(['Goods Receipt', 'PO Return', 'Sale Issue', 'Sale Return']);
        setNonMatChallanType(['Material Issue', 'Material Receipt', 'JO Return', 'Sale Issue', 'Sale Return']);
        setPrdType(response.data.product.includes('Fabric') ? 'Fabric' : 'Made-up');
        response.data.challanDate = dayjs(response.data.challanDate);
        setTitle('Edit Challan');
        setPOJOType(response.data.pojoType);
        setType(response.data.type);
        setChallanData(response.data);
        setChallanDetail(response.data.challanDetail);
        setSource(response.data.source);
        setDestination(response.data.destination);
        setQuantity(response.data.quantity);
        setMaterialCost(response.data.materialCost);
        setProcessingCost(response.data.processingCost);
        setTotalCost(response.data.totalCost);
        setPlannedOutput(response.data.plannedOutput);
        setShowDetails(response.data.type === 'Material Issue');
        setLoader(false);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoader(false);
      });
    } else if('Sale Issue' === pojoData.challanType || 
              'Sale Return' === pojoData.challanType || 
              'Supplier Return' === pojoData.challanType) {
      setMatChallanType(['Sale Issue', 'Sale Return', 'Supplier Return']);
      setNonMatChallanType(['Sale Issue', 'Sale Return', 'Supplier Return']);
      setPrdType(pojoData.product.includes('Fabric') ? 'Fabric' : 'Made-up');
      setLoader(false);
      setType(pojoData.challanType);
      pojoData.challanDate = dayjs();
      pojoData.inputCode = pojoData.code;
      pojoData.inputName = pojoData.input;
      pojoData.outputUom = pojoData.uom;
      pojoData.type = pojoData.challanType;
      pojoData.quantity = null;
      setChallanData(pojoData);
      setSource('Sale Issue' === pojoData.challanType || 'Supplier Return' === pojoData.challanType ? LFH_HOME : pojoData.customer);
      setDestination('Sale Issue' === pojoData.challanType ? pojoData.customer : 
                     'Sale Return' === pojoData.challanType ? LFH_HOME : pojoData.supplier);
      setTitle('Create Challan');
      setShowDetails(false);
    } else {
      createChallanFromPOJOId(pojoData.rowId, stockModel, appContext,
      (response: any) => {
        response.data.type = 'Purchase Order' === response.data.pojoType ? 'Goods Receipt' : 'Material Issue'
        setPrdType(response.data.product.includes('Fabric') ? 'Fabric' : 'Made-up');
        response.data.challanDate = dayjs(response.data.challanDate);
        setSource('Material Issue' === response.data.type ? LFH_HOME : response.data.supplier);
        setDestination('Material Issue' === response.data.type ? response.data.supplier : LFH_HOME);
        setTitle('Create Challan');
        setType(response.data.type);
        setPOJOType(response.data.pojoType);
        setChallanData(response.data);
        setChallanDetail(response.data.challanDetail);
        setMaterialCost(response.data.materialCost);
        setProcessingCost(response.data.processingCost);
        setTotalCost(response.data.totalCost);
        setShowDetails(response.data.type === 'Material Issue');
        setLoader(false);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoader(false);
      });
    }
  }, []);

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const handleCellClick = (value: any) => {
    if('print' === value.field) {
      if(isEmpty(challanId)) {
        appContext.setDialogMessage('Save challan first.');
      } else {
        setChallanDetailId(value.row.rowId);
        setOpenEditPrint(true);
      }
    }
  }

  const handleCellDoubleClick = (value: any) => {
    if('plannedInput' === value.field) {
      setRowValue(value.row);
      setInputLabel('Planned Input');
      setOpenInput(true);
    }
  }

  const closeEditPrintPopup = () => {
    setOpenEditPrint(false);
  }

  function validateDetails() {
    for(let i = 0; i < challanDetail.length; ++i) {
      let detail = challanDetail[i];
      if((isEmpty(detail.plannedInput) && 'NA' !== detail.inputCode) || isEmpty(detail.inputUom)) {
        appContext.setDialogMessage('Enter planned input.');
        return false;
      }
      
      if(Math.round(detail.plannedInput) > Math.round(detail.availableInput)) {
        appContext.setDialogMessage('Planned input cannot be more than available input.');
        return false;
      }

      if(Math.round(detail.plannedInput) > Math.round(detail.inputQuantity * 1.05)) {
        //appContext.setDialogMessage('Planned input cannot be more than required input.');
        //return false;
      }
    }

    return true;
  }

  function calculateReceiptCost(value: any) {
    let quantity = value;
    let matCost = 0;
    let procCost = 0;
    let totalCost = 0;

    if(isNotEmpty(challanDetail)) {
      for(let i = 0; i < challanDetail.length; ++i) {
        let detail = challanDetail[i];
        let plannedInput = (+quantity / +challanData.outputQuantity) * +detail.inputQuantity;
        detail.plannedInput = plannedInput;
        detail.materialCost = plannedInput * +detail.unitMaterialCostReceipt;
      }
    }

    if('Material' === challanData.inputType) {
      matCost = Math.round(challanData.unitCost * quantity);
      totalCost = matCost;
    } else {
      procCost = Math.round(+quantity * +challanData.unitCost * challanData.consumption/challanData.output);
      matCost = Math.round(+quantity * +challanData.unitMaterialCostProcess);
      totalCost = +matCost + +procCost;
    }

    setMaterialCost(matCost);
    setProcessingCost(procCost);
    setTotalCost(totalCost);
  }

  function calculatePlannedOutput() {
    let plannedOutput = challanData.outputQuantity * challanDetail[0].plannedInput/challanDetail[0].inputQuantity;
    for(let i = 0; i < challanDetail.length; ++i) {
      let detail = challanDetail[i];
      let output = challanData.outputQuantity * detail.plannedInput/detail.inputQuantity;
      if(output < plannedOutput) {
        plannedOutput = output;
      }
    }
    setPlannedOutput(plannedOutput);
    calculateIssueCost(plannedOutput);
  }
  
  function calculateIssueCost(value: any) {
    let plannedOutput = value;
    let matCost = 0;
    let procCost = 0;
    let totalCost = 0;
    for(let i = 0; i < challanDetail.length; ++i) {
      let detail = challanDetail[i];
      detail.plannedInput = Math.round(detail.plannedInput);
      detail.materialCost = Math.round(+detail.plannedInput * +detail.unitMaterialCost);
      matCost += +detail.materialCost;
    }

    if('Material' === challanData.inputType) {
      matCost = Math.round(challanData.unitCost * plannedOutput);
      totalCost = matCost;
    } else {
      procCost = Math.round(plannedOutput * challanData.unitCost * challanData.consumption/challanData.output);
      totalCost = matCost + procCost;
    }
    
    setMaterialCost(matCost);
    setProcessingCost(procCost);
    setTotalCost(totalCost);
  }

  const onTypeChange = (e: any) => {
    let type = e.target.value;
    setType(type);
    setSource('Material Issue' === type || 'PO Return' === type || 'JO Return' === type ? LFH_HOME : challanData.supplier);
    setDestination('Material Issue' === type || 'PO Return' === type || 'JO Return' === type ? challanData.supplier : LFH_HOME);
    if('Material Issue' === type) {
      setShowDetails(true);
      calculateIssueCost(plannedOutput);
    } else {
      setShowDetails(false);
      calculateReceiptCost(quantity);
    }
  }

  const onSubmit = (data: any) => {
    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    let poDate = dayjs(dayjs(data.poDate).format('YYYY-MM-DD'));
    let challanDate = dayjs(dayjs(data.challanDate).format('YYYY-MM-DD'));

    if(challanDate.isAfter(today)) {
      appContext.setDialogMessage('Future challan date is not allowed.');
      return;
    } else if(challanDate.isBefore(poDate)) {
      appContext.setDialogMessage('Challan date is before PO/JS date.');
      return;
    }

    if('Material Issue' === type && !validateDetails()) {
      return;
    }

    if((('Goods Receipt' === type || 'Material Receipt' === type) || 'PO Return' === type || 'Supplier Return' === type || 
         'JO Return' === type || 'Sale Issue' === type || 'Sale Return' === type) && data.quantity <= 0) {
      appContext.setDialogMessage('Quantity should be greater than 0.');
      return;
    }

    if('Material Issue' === type && plannedOutput <= 0) {
      appContext.setDialogMessage('Planned output should be greater than 0.');
      return;
    }

    if('Material Issue' === type && materialCost <= 0) {
      appContext.setDialogMessage('Material cost should be greater than 0.');
      return;
    }

    data.challanDetail = challanDetail;
    data.pojoType = pojoType;
    data.source = source;
    data.destination = destination;
    data.quantity = quantity;
    data.plannedOutput = Math.round(plannedOutput);
    data.materialCost = Math.round(materialCost);
    data.processingCost = Math.round(processingCost);
    data.totalCost = Math.round(totalCost);
    data.inputId = challanData.inputId;

    saveChallan(data, appContext,
      (response: any) => {
        appContext.setDialogMessage('Update applicable quality checks.');
        navigate(-1);
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const openSpecsPage = () => {
    openSpecsPopup(challanData.inputCode, challanData.inputId);
  }

  const flipShowDetails = () => {
    if(type === 'Material Receipt') {
      setShowDetails(!showDetails);
    }
  }

  const closeInputPopup = (value: any) => {
    if('Ok' === value) {
      calculatePlannedOutput();
    }
    setOpenInput(false);
  }

  const updateAvailableQtyData = (e: any) => {
    challanData.challanDate = e;
    setLoading(true);
    updateAvailableQty(challanData, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setChallanDetail(response.data.challanDetail);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <ITextField name='challanCode' label='Code' required={false} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='product' label='Product' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputType' label='Input Type' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputName' label='Input Name' required={true} disabled={true}
          InputProps={{startAdornment: (<InputAdornment position="start"> 
                        <IconButton onClick={flipShowDetails} edge="start">
                        <Visibility fontSize='small'/></IconButton> </InputAdornment>)}}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputCode' label={'Input Code'} required={true} disabled={true}
          InputProps={{startAdornment: (<InputAdornment position="start"> 
                      <IconButton onClick={openSpecsPage} edge="start">
                      <Visibility fontSize='small'/></IconButton> </InputAdornment>)}}/>
      </Grid>
      {'Sale Issue' !== type && 'Sale Return' !== type && <Grid xs={2}>
        <INumberField name='unitCost' label={'Unit Cost'} required={true} disabled={true}/>
      </Grid>}
      <Grid xs={2}>
        <ITextField name='outputDesc' label={'Output Description'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='outputUom' label={'Output UOM'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='supplier' label='Supplier' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <IDateField name='challanDate' label='Challan Date' required={true} disabled={false}
          onActionEvent={(e: any) => updateAvailableQtyData(e)}/>
      </Grid>
      <Grid xs={2}>
        <TextField name='source' label='Source' required={true} disabled={true} value={source} 
          margin='dense' inputProps={{ style: { height: "9px"}}}/>
      </Grid>
      <Grid xs={2}>
        <TextField name='destination' label='Destination' required={true} disabled={true} value={destination} 
          margin='dense' inputProps={{ style: { height: "9px"}}}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='remarks' label='Remarks'/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='type' label={'Challan Type'} 
          itemList={'Material' === challanData.inputType ? matChallanType : nonMatChallanType} 
          disabled={isNotNull(challanId) || 'Sale Issue' === type || 'Sale Return' === type || 'Supplier Return' === type ? true : false} 
          required={true} onChangeEvent={(e: any) => onTypeChange(e)}/>
      </Grid>
      {('Goods Receipt' === type || 'PO Return' === type || 'JO Return' === type || 'Supplier Return' === type || 
        'Material Receipt' === type || 'Sale Issue' === type || 'Sale Return' === type) && 
      <Grid xs={2}>
        <INumberField name='quantity' label={'Quantity'} required={true} disabled={false} 
          onActionEvent={(e: any) => {setQuantity(Math.round(e.target.value)); calculateReceiptCost(Math.round(e.target.value))}} />
      </Grid>}
      {'Material Issue' === type && <Grid xs={2}>
        <TextField name='plannedOutput' label={'Planned Output'} required={true} disabled={true} 
          value={formatTo0Decimal(plannedOutput) + ' ' + challanData.outputUom} margin='dense' inputProps={{ style: { height: "9px"}}}/>
      </Grid>}
      {('Goods Receipt' === type || 'Material Receipt' === type) && <Grid xs={2}>
        <ITextField name='supplierChallan' label='Supplier Challan'/>
      </Grid>}
      {'Material Issue' !== type && 'PO Return' !== type && 'JO Return' !== type && <Grid xs={2}>
        <ITextField name='outputDetail' label='Output Detail'/>
      </Grid>}
      {'Material Issue' !== type && <Grid xs={2}>
        <ITextField name='hsnCode' label={'HSN Code'} required={true} disabled={false}/>
      </Grid>}
      {('Material Issue' === type || 'Sale Issue' === type) && <Box sx={{ width: '98.5%', marginLeft: 1.35, marginTop: 2}}>
        <Divider>
          <Typography sx={{fontSize: 14, fontWeight: 'bold'}}>Delivery Address</Typography>
        </Divider>
        <Grid container spacing={1} sx={{marginTop: 1}}>
          <Grid xs={4}>
            <ITextField name='address1' label='Address Line 1' required={true} disabled={'Amazon.com' !== destination}/>
          </Grid>
          <Grid xs={4}>
            <ITextField name='address2' label='Address Line 2' required={true} disabled={'Amazon.com' !== destination}/>
          </Grid>
          <Grid xs={4}>
            <ITextField name='address3' label='Address Line 3' required={true} disabled={'Amazon.com' !== destination}/>
          </Grid>
        </Grid>
      </Box>}
      {('Material Issue' === type || 'Sale Issue' === type) && <Box sx={{ width: '98.5%', marginLeft: 1.35, marginTop: 2}}>
        <Divider>
          <Typography sx={{fontSize: 14, fontWeight: 'bold'}}>Transportation Details</Typography>
        </Divider>
        <Grid container spacing={1} sx={{marginTop: 1}}>
          <Grid xs={3}>
            <IDropdown name='transporter' label='Transporter' url={GET_ALL_TRANSPORTER_URL} required={false}/>
          </Grid>
          <Grid xs={3}>
            <ITextField name='vehicleNumber' label='Vehicle Number' required={false}/>
          </Grid>
          <Grid xs={3}>
            <ITextField name='driverName' label='Driver Name' required={false}/>
          </Grid>
          <Grid xs={3}>
            <INumberField name='driverNumber' label='Driver Number' required={false}/>
          </Grid>
        </Grid>
      </Box>}
      {('Sale Issue' === type) && <Box sx={{ width: '98.5%', marginLeft: 1.35, marginTop: 2}}>
        <Divider>
          <Typography sx={{fontSize: 14, fontWeight: 'bold'}}>Print Data</Typography>
        </Divider>
        <Grid container columnSpacing={1} rowSpacing={0}>
          {MATERIAL_SPECS_MAP[prdType].map((spec: SpecListItem) => {
            return <Grid xs={'Made-up' === prdType ? 2 : 1.5}>
                    <ITextField name={spec.fieldObject} label={spec.fieldName} required={false} />
                   </Grid>})}
        </Grid>
      </Box>}
      {('Material Issue' === type || 'Material Receipt') && showDetails && <Grid container spacing={0}>
        <IGridComponent title={'Input Details'} rows={challanDetail} columns={columns} 
          getRowId={(row: any) => row.serial} maxHeight={"60vh"} readOnly={type !== 'Material Issue'}
          apiRef={props.apiRef} showAction={false} showAddBtn={false} hideFooter={true} hideFooterPagination={true} 
          loading={loading} cellClick={handleCellClick} cellDoubleClick={handleCellDoubleClick}/> </Grid>}
        <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
          dialogBody={<SpecsComponent data={specsData} />} />
        <IDialogComponent onClose={closeEditPrintPopup} open={openEditPrint} title='Print Data'
          dialogBody={<PrintChallanForm detailId={challanDetailId} close={closeEditPrintPopup} />} />
        <IDialogComponent onClose={closeInputPopup} open={openInput} title='Specify Value'
          dialogBody={<EditCellComponent data={rowValue} close={closeInputPopup} label={inputLabel}/>} />
      {'Sale Issue' !== type && 'Sale Return' !== type && 'Supplier Return' !== type &&
      <Grid xs={12} display="flex" justifyContent="center">
        <Grid container columnSpacing={1} rowSpacing={0} 
            sx={{ maxWidth: '850px', border: '1px solid #D3D3D3', borderRadius: '4px', p: 0, mt: '10px'}}>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatTo0Decimal(materialCost)} label={'Material Cost'} />
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatTo0Decimal(processingCost)} label={'Process Cost'} />
          </Grid>
          <Grid xs={4}>
            <IReadOnlyField value={'₹ ' + formatTo0Decimal(totalCost)} label={'Total Cost'} />
          </Grid>
        </Grid>
      </Grid>}
    </Grid>
  }

  return loader ? <></> : <IForm formData={challanData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default ChallanForm;